import { EligibilityDeterminationOthers } from '../../../pages/eligibility/types';
import { ApiResponseHandler } from '../../ApiResponseHandler';
import ThomApiClient from '../../ThomApiClient';

export const addOrUpdateEligibilityDeterminationApi = async (
  evaluationId: string,
  params: EligibilityDeterminationOthers,
): Promise<EligibilityDeterminationOthers> => {
  const url = params.id
    ? `eds/${params.id}?evaluationId=${evaluationId}`
    : `eds?evaluationId=${evaluationId}`;

  if (params.id) {
    // Update existing record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().put<
        EligibilityDeterminationOthers,
        EligibilityDeterminationOthers
      >(url, params),
    );
  } else {
    // Create new record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().post<
        EligibilityDeterminationOthers,
        EligibilityDeterminationOthers
      >(url, params),
    );
  }
};

export const getEligibilityDeterminationFormApi = async (
  id: string,
): Promise<EligibilityDeterminationOthers> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<EligibilityDeterminationOthers>(
      `eds?evaluationId=${id}`,
    ),
  );
};
